module.exports = __webpack_public_path__ + "static/media/curves_cacao.a73e63b1.jpg";